import { DEEP_BLUE, WHITE } from '../../../ThemeContext/constants';
import { theme } from '../../../ThemeContext/ThemeObject';
import {
  centeredModalSurfaceStyles,
  modalConfirmationButtonCommonStyles
} from '../../shared/commonStyles';
import { closeIcon } from '../../shared/styleClasses';

export const classes = {
  modal: {
    ...centeredModalSurfaceStyles,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '60px',
    maxWidth: '1100px',
    width: '100%',
    height: '94vh',
    maxHeight: '844px',
    dropShadow: '0px 2px 14px #305A6F29'
  },
  closeIcon,
  modalHeader: {
    fontFamily: 'Source Sans Pro',
    fontSize: '38px',
    fontWeight: '700',
    color: DEEP_BLUE,
    width: '100%',
    height: '40px'
  },
  modalFooter: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'flex-end',
    columnGap: '20px',
    paddingTop: '10px'
  },
  modalButtonBase: {
    ...modalConfirmationButtonCommonStyles,
    padding: '8px 20px',
    '&:focus': {
      outline: 'none'
    }
  },
  modalSecondaryButton: {
    textDecoration: 'underline',
    color: theme.palette.error.main,
    backgroundColor: WHITE,
    '&:hover': {
      backgroundColor: WHITE,
      textDecoration: 'none',
      boxShadow: 'none'
    }
  }
};
